import React, { useRef, useState } from 'react';
import { LupaDeImagen } from '../../components/LupaDeImagen';

/**
 * Imagen generada con la lupa del historial encima: al pasar el mouse, un círculo amplía
 * el lugar del cursor (ADR-2026-10-13-lupa-y-alta-de-producto-en-el-test-masivo).
 *
 * `<img>` y no CachedImg: la lupa necesita el ref del elemento, y estas son las `full/`
 * firmadas que se ven ampliadas una vez. Mientras la imagen no cargó la lupa queda
 * apagada (no hay nada que ampliar).
 */
const ImagenConLupa: React.FC<{
  src: string;
  className?: string;
  /** El overlay donde vive la imagen: la capa de la lupa va por encima. */
  zIndex: number;
  zoom?: number;
}> = ({ src, className, zIndex, zoom = 2.5 }) => {
  const imgRef = useRef<HTMLImageElement>(null);
  const [cargada, setCargada] = useState(false);
  return (
    <>
      <img
        ref={imgRef}
        src={src}
        alt=""
        decoding="async"
        draggable={false}
        onLoad={() => setCargada(true)}
        className={`cursor-zoom-in ${className ?? ''}`}
      />
      <LupaDeImagen imgRef={imgRef} src={src} habilitada={cargada} zoom={zoom} tamano={220} zIndex={zIndex + 1} />
    </>
  );
};

export default ImagenConLupa;
